import { render, staticRenderFns } from "./ClientEmailAdd.vue?vue&type=template&id=6df0d334&scoped=true"
import script from "./ClientEmailAdd.vue?vue&type=script&lang=js"
export * from "./ClientEmailAdd.vue?vue&type=script&lang=js"
import style0 from "./ClientEmailAdd.vue?vue&type=style&index=0&id=6df0d334&prod&lang=css"
import style1 from "./ClientEmailAdd.vue?vue&type=style&index=1&id=6df0d334&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df0d334",
  null
  
)

export default component.exports